import { render, staticRenderFns } from "./ExceptionWithImg.vue?vue&type=template&id=37b1c476&scoped=true&"
import script from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
export * from "./ExceptionWithImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1c476",
  null
  
)

export default component.exports